




















































































































































































































































import { appModule } from "@/store/modules/app";
import { storePerawat } from "@/store/modules/perawat";
import { userModule } from "@/store/modules/user";
import moment from "moment";
import { Component, Vue, Prop, Watch, Ref } from "vue-property-decorator";
import ModalAskepOptions from "@/components/modal/ModalAskepOptions.vue";
import AsuhanKebidananGadarStore from "@/store/modules/AsuhanKebidananGadarStore";
// import AsesmenKeperawatanGadarStore from "@/store/modules/AsesmenKeperawatanGadarStore";
import AsuhanKebidananGawatDarurat from "@/services/AsuhanKebidananGawatDarurat";
import {
  makeListWithEditable,
  dedupeAsuhanItems
} from "@/utility/AsuhanKeperawatanHelper";
import AsesmenGadarKeperawatanStore from "@/store/modules/AsesmenAwalGadar/AsesmenGadarKeperawatanStore";
import { isEmpty } from "lodash";
import { capitalizeFirstLetter } from "@/utility/CommonHelper";

interface Options {
  type: string;
  title: string;
  options: any[];
  column: number;
}

@Component({
  components: {
    ModalAskepOptions
  }
})
export default class AskepGadarInputModal extends Vue {
  @Prop() readonly value!: boolean;
  @Prop() readonly register!: number;
  @Prop() readonly rm!: number;
  @Prop() editedItem = null as {
    id: number;
    diagnosis: any;
    usiaHamil: number;
    intervensi: any[];
    creator: any;
    examinedAt: string;
  };
  @Ref() readonly diagCustom;
  @Ref() readonly diagAutocomplete;
  @Ref() readonly dateTimePicker;
  @Ref() readonly intervensiItemRow: HTMLInputElement;

  diagSearch = null;
  diagnosisCustom = null;
  showCustomDiag = false;
  showIntervensiTimepicker = false;

  get show() {
    return this.value;
  }
  set show(val) {
    this.$emit("input", val);
  }

  get diagnosisOptions() {
    return AsuhanKebidananGadarStore.listDiag
      .slice()
      .sort((a, b) => a.name.localeCompare(b.name));
  }

  get intervensiOptions() {
    const list = AsuhanKebidananGadarStore.listIntervensi
      .slice()
      .sort((a, b) => a.name.localeCompare(b.name))
      .map(item => ({ ...item, time: null }));

    return makeListWithEditable(list, ".....");
  }

  get optionsType() {
    return [
      {
        type: "intervensi",
        title: "Intervensi Keperawatan",
        options: this.intervensiOptions,
        column: 3
      }
    ];
  }

  modalOptionsTitle = "Input Askep";
  modalTitle = "Tambah Askep";

  id = null;
  usiaHamilMinggu: number = null;
  usiaHamilHari: number = null;
  diagnosis = null;
  intervensi = [];
  creator: {
    id: number;
    nama: string;
  } = null;
  examinedAt = null;
  usiaHamilVal: number = null;

  saving = false;

  showOptionsModal = false;
  groupItem = [];
  selectedOptionItems = [];
  activeOptionsType: Options = null;

  timePickerProps = { format: "24hr", scrollable: true };
  datePickerProps = { locale: "id", max: moment().format("YYYY-MM-DD") };

  get user() {
    return userModule.user;
  }

  get listPerawat() {
    return storePerawat.listPerawat;
  }

  get asesmenKeperawatan() {
    // return AsesmenKeperawatanGadarStore.asesmen?.content;
    return AsesmenGadarKeperawatanStore.asesmen?.content;
  }

  get g(): number {
    return this.asesmenKeperawatan?.riwayatObstetri?.g ?? 0;
  }

  get p(): number {
    return this.asesmenKeperawatan?.riwayatObstetri?.p ?? 0;
  }

  get a(): number {
    return this.asesmenKeperawatan?.riwayatObstetri?.a ?? 0;
  }

  get ah(): number {
    return this.asesmenKeperawatan?.riwayatObstetri?.ah ?? 0;
  }

  get usiaHamil() {
    return this.asesmenKeperawatan?.riwayatObstetri?.usiaHamil ?? null;
  }

  get diagnosisInput() {
    if (!isEmpty(this.diagnosis)) {
      return this.diagnosis;
    } else if (!isEmpty(this.diagnosisCustom)) {
      return {
        id: null,
        name: this.diagnosisCustom
      };
    } else {
      return null;
    }
  }

  get input() {
    return {
      register_id: this.register,
      pasien_rm: this.rm,
      content: {
        g: this.g,
        p: this.p,
        a: this.a,
        ah: this.ah,
        usiaHamil: this.usiaHamilVal,
        diagnosis: this.diagnosisInput,
        intervensi: dedupeAsuhanItems(this.intervensi),
        // bidan: this.listPerawat.find(prwt => prwt.id == this.creator.id),
        bidan: this.creator,
        examinedAt: this.examinedAt
          ? moment(this.examinedAt).format("YYYY-MM-DD HH:mm:ss")
          : null
      }
    };
  }

  setAskebOptionItems(val) {
    if (this.activeOptionsType) {
      this[this.activeOptionsType.type] = dedupeAsuhanItems(val);
    }
  }

  setIntervensi(val) {
    this.intervensi = dedupeAsuhanItems(val);
  }

  openInputIntervensiModal() {
    const options = this.optionsType.find(item => item.type === "intervensi");

    this.activeOptionsType = options;
    this.groupItem = options.options;
    this.selectedOptionItems = this.intervensi;

    this.showOptionsModal = true;
  }

  save() {
    if (!this.saving) {
      this.saving = true;

      const sendRequest = this.id
        ? AsuhanKebidananGawatDarurat.update(this.id, this.input)
        : AsuhanKebidananGawatDarurat.create(this.input);

      sendRequest
        .then(() => {
          // set store module

          appModule.NoticeDelay("Berhasil Simpan Asuhan Kebidanan");

          this.close();

          this.$emit("saved");
        })
        .finally(() => {
          this.saving = false;
        });
    }
  }

  setPerawat(val) {
    this.creator = val;
  }

  clearInputField() {
    this.id = null;
    this.usiaHamilHari = null;
    this.usiaHamilMinggu = null;
    this.diagnosis = null;
    this.intervensi = [];
    this.creator = {
      id: this.user.id,
      nama: this.user.nama
    };
    this.examinedAt = null;

    this.showCustomDiag = false;
    this.diagnosisCustom = null;
    this.diagSearch = null;

    this.editedItem = null;

    // trigger datetimepicker to clear value
    this.$refs.dateTimePicker["clearHandler"]();
  }

  splitUsiaHamil(val) {
    if (val) {
      const hr = val % 7,
        mg = (val - hr) / 7;

      return [mg, hr];
    }

    return [null, null];
  }

  @Watch("show")
  changedShow(val) {
    if (val && this.editedItem !== null) {
      this.modalTitle = "Edit Askeb";

      const [mg, hr] = this.splitUsiaHamil(this.editedItem.usiaHamil);

      this.id = this.editedItem.id;
      this.usiaHamilHari = hr;
      this.usiaHamilMinggu = mg;
      this.diagnosis = this.editedItem.diagnosis;
      this.intervensi = dedupeAsuhanItems(this.editedItem.intervensi);
      this.creator = this.editedItem.creator;
      this.examinedAt = new Date(this.editedItem.examinedAt);
    } else {
      this.modalTitle = "Tambah Askeb";
    }

    if (val) {
      this.changeUsiaHamil(this.usiaHamil);
    }
  }

  @Watch("usiaHamil")
  changeUsiaHamil(val) {
    this.usiaHamilVal = val;

    if (val && !this.usiaHamilHari && !this.usiaHamilMinggu) {
      this.usiaHamilHari = val % 7;
      this.usiaHamilMinggu = (val - this.usiaHamilHari) / 7;
    }
  }

  @Watch("usiaHamilHari")
  changeUsiaHamilHari(val: string): void {
    this.usiaHamilHari = parseInt(val);
    this.usiaHamilVal = parseInt(val) + this.usiaHamilMinggu * 7;
  }

  @Watch("usiaHamilMinggu")
  changeUsiaHamilMinggu(val: string): void {
    this.usiaHamilMinggu = parseInt(val);
    this.usiaHamilVal = parseInt(val) * 7 + this.usiaHamilHari;
  }

  @Watch("diagnosis")
  changedDiagnosis(val) {
    if (!isEmpty(val)) {
      this.showCustomDiag = false;
    }
  }

  @Watch("showCustomDiag")
  changedShowCustomDiag(val) {
    if (!val) {
      this.diagnosisCustom = null;
    }
  }

  get isAnyIntervensiCustom() {
    return this.intervensi.some(item => !item.id);
  }

  close() {
    if (this.diagnosisCustom) {
      AsuhanKebidananGadarStore.getListDiagnosis();
    }

    if (this.isAnyIntervensiCustom) {
      AsuhanKebidananGadarStore.getListIntervensi();
    }

    this.show = false;
    this.clearInputField();
  }

  addDiag() {
    this.diagnosis = null;
    this.showCustomDiag = true;
    this.$refs.diagAutocomplete["isMenuActive"] = false;

    this.$nextTick(() => {
      this.diagCustom.focus();
      this.diagnosisCustom = capitalizeFirstLetter(this.diagSearch);
      this.diagSearch = "";
    });
  }

  addNewAsuhanItem(catName) {
    this[catName] = [
      ...this[catName],
      {
        id: null,
        editable: true,
        name: ".....",
        time: null
      }
    ];

    this.$nextTick(() => {
      const inputRows = this[`${catName}ItemRow`].length;
      this[`${catName}ItemRow`][inputRows - 1].focus();
    });
  }

  removeAsuhanItem(catName, index) {
    this[catName] = [
      ...this[catName].slice(0, index),
      ...this[catName].slice(index + 1)
    ];
  }
}
